import { defineQuery, Not } from "bitecs";
import { Vector3 } from "three";
import { ModelComponent } from "../components/ModelComponent";
import { MovementGoalComponent } from "../components/MovementGoalComponent";
import { TagPetComponent } from "../components/TagPetComponent";
import { TagTouchedComponent } from "../components/TagTouchedComponent";
import { TinyPetsWorld } from "../TinyPetsWorld";

export const createRotationSystem = (
    world: TinyPetsWorld,
    camera: THREE.Camera,
    config: {}
): {
    rotationSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const query = defineQuery([
        MovementGoalComponent,
        ModelComponent,
        Not(TagTouchedComponent),
    ]);

    const touchedQuery = defineQuery([
        ModelComponent,
        TagPetComponent,
        TagTouchedComponent,
    ]);

    return {
        rotationSystem: (world: TinyPetsWorld) => {
            query(world).forEach((eid: number) => {
                if (world.render.models[eid]) {
                    // update the rotation by terribly a) making the model look at the target and then
                    // b) copying those values into the ModelComponent component :facepalm:
                    world.render.models[eid].scene.lookAt(
                        new Vector3(
                            MovementGoalComponent.x[eid],
                            MovementGoalComponent.y[eid],
                            MovementGoalComponent.z[eid]
                        )
                    );

                    ModelComponent.rotation[eid].set(
                        world.render.models[eid].scene.rotation
                            .toVector3()
                            .toArray()
                    );
                }
            });

            touchedQuery(world).forEach((eid: number) => {
                if (world.render.models[eid]) {
                    const target = camera.position.clone();
                    // update the rotation by terribly a) making the model look at the target and then
                    // b) copying those values into the ModelComponent component :facepalm:
                    world.render.models[eid].scene.lookAt(target);

                    ModelComponent.rotation[eid].set(
                        world.render.models[eid].scene.rotation
                            .toVector3()
                            .toArray()
                    );
                }
            });

            return world;
        },
    };
};
